<script lang="ts">
  import { handleUploadFiles } from '../helpers/handle-upload-files';
  import { ConfigStore } from '../store/config';
  import { getAddFilesConfig } from '../helpers/features';
  import SvgIcon from './svg-icon.svelte';

  function handleUpload(e: Event) {
    const files = (e.target as HTMLInputElement)?.files;
    if (!files) return;

    handleUploadFiles(files);
    (e.target as HTMLInputElement).value = '';
  }

  $: fileTypes = getAddFilesConfig($ConfigStore)?.fileTypes;
  $: acceptTypes =
    fileTypes && fileTypes.length
      ? fileTypes.join(',')
      : 'image/png,image/jpeg,image/webp,image/gif';
</script>

<div class="cs-file-attachment-button-wrapper">
  <input
    class="cs-file-attachment-input"
    type="file"
    name="albumImage"
    accept={acceptTypes}
    multiple
    on:change={handleUpload}
  />
  <div class="cs-file-attachment">
    <SvgIcon name="paperclip" />
    <span class="cs-file-attachment-label">Upload File</span>
  </div>
</div>

<style lang="scss">
  @use './../../scss/components/file-attachment-button';
</style>
